import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ReactGa from "react-ga4";

ReactGa.initialize("G-ZHL21KDL1T"); //
ReactGa.send("Shlédnutí stránky");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
